import React, { Component } from 'react';

import '../css/misvis.css'

import logomision from '../img/mision-ico.svg'
import logovision from '../img/vision-ico.svg'

class Quienessomos extends Component {
  render() {
    return (
      <div className="container">

        <div className="misvis row no-gutters">

          <div className="misvistodo container col-lg">

            <div className="row no-gutters justify-content-center col p-5">

              <div className="misviscontenedor col-12 col-lg-3">
                <img className="logomisvis" src={logomision} alt=""/>
              </div>

              <div className="textomisvistodo container col-12 col-lg-8 mx-n1">
                <div className="row">

                  <div className="titulomisvis col-12">
                    Misión
                  </div>

                  <div className="textomisvis col-12">
                    <p>Satisfacer las necesidades de nuestros clientes con eﬁciencia en el servicio, variedad de productos, y la mejor relación entre precio y calidad. Estar en permanente evolución con productos de vanguardia que aseguren las mejores alternativas en la construcción o remodelación.</p>
                  </div>

                </div>
              </div>

            </div>

          </div>

          <div className="misvistodo container col-lg">

            <div className="row no-gutters justify-content-center col p-5">

              <div className="misviscontenedor col-12 col-lg-3">
                <img className="logomisvis" src={logovision} alt=""/>
              </div>

              <div className="textomisvistodo container col-12 col-lg-8 mx-n1">
                <div className="row">

                  <div className="titulomisvis col-12">
                    Visión
                  </div>

                  <div className="textomisvis col-12">
                    <p>Ser la empresa ferretera más sólida en el norte del Distrito Metropolitano de Quito, reconocidos por nuestra variedad de productos, excelente precios y por la innovación tecnológica para atención de nuestros clientes. </p>
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    )
  }
}

export default Quienessomos;
